var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrips({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87467 6.37499C5.24388 6.37499 6.35384 5.26503 6.35384 3.89582C6.35384 2.52662 5.24388 1.41666 3.87467 1.41666C2.50547 1.41666 1.39551 2.52662 1.39551 3.89582C1.39551 5.26503 2.50547 6.37499 3.87467 6.37499Z",
    stroke: "#44585F",
    strokeWidth: 1.0625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0202 10.625H14.1452C14.9243 10.625 15.5618 11.2625 15.5618 12.0417V14.1667C15.5618 14.9458 14.9243 15.5833 14.1452 15.5833H12.0202C11.241 15.5833 10.6035 14.9458 10.6035 14.1667V12.0417C10.6035 11.2625 11.241 10.625 12.0202 10.625Z",
    stroke: "#44585F",
    strokeWidth: 1.0625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50019 3.54166H10.3985C11.7089 3.54166 12.3181 5.16374 11.3335 6.02791L5.67395 10.9792C4.68936 11.8362 5.29853 13.4583 6.60186 13.4583H8.50019",
    stroke: "#44585F",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88613 3.89582H3.89432",
    stroke: "#44585F",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0946 13.1042H13.1028",
    stroke: "#44585F",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.0f51ac7cf5054086ad947032d7de47ce.svg";
export { ForwardRef as ReactComponent };